module.exports = __webpack_public_path__ + "static/img/icon7-12.a95b4d2b.png";